module.exports = __webpack_public_path__ + "media/images/course_section_2-2da0c68c295d82548eeb8bbd19ca0046.png";